import { render, staticRenderFns } from "./FilterCard.vue?vue&type=template&id=821808f8&"
import script from "./FilterCard.vue?vue&type=script&lang=js&"
export * from "./FilterCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports